<script setup lang="ts">
  import { InputText } from "primevue";
  import Message from "@/ui/message/message.vue";
  import { useField } from "vee-validate";
  import { watch } from "vue";
  import { PropType } from "vue";

  // @ts-ignore
  InputText.compatConfig = {
    MODE: 3,
    COMPONENT_V_MODEL: false,
  };

  const props = defineProps({
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    capitalize: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: Object as PropType<{
        input: string;
      }>,
      default: () => ({}),
    },
  });

  const { value: localValue, errorMessage } = useField<string>(() => props.name);

  watch(localValue, (newValue) => {
    if (props.capitalize) {
      localValue.value = capitalizeFirstLetter(newValue);
    }
  });

  // Capitalize the first letter on input
  const capitalizeFirstLetter = (string: string) => {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  };
</script>

<template>
  <div class="flex flex-col gap-[4px]">
    <label v-if="label" :for="name" class="text-[14px] font-normal">
      {{ label }}
      <span v-if="required" class="text-[#FF55C6]">*</span>
    </label>
    <InputText v-bind="$attrs" :id="name" v-model="localValue" :invalid="!!errorMessage" :class="classes.input" />
    <Message class="errorMessage" v-if="errorMessage" severity="error" size="small" variant="simple" :text="errorMessage" />
  </div>
</template>
